<template>
	<v-btn 
		:color="color"
		:href="href"
		target="_blank"
		:title="title"
		v-bind="$attrs"
	>
		<slot>
			<v-icon class="mr-1">
				mdi-chat-outline
			</v-icon>
			Line
		</slot>
	</v-btn>
</template>

<script>

const nuxtConfig = require('~/nuxt.config').default

export default {
	data:() => ({
		color: undefined,
		href: undefined,
		title: undefined
	}),
	mounted() {
		let getParams = this.$attrs.params || ''
		this.color = this.$attrs.color || 'light-green darken-1 white--text'
		this.url = `${nuxtConfig.hostname}${this.$route.fullPath}`
		this.href = this.$attrs.url ? `https://social-plugins.line.me/lineit/share?url=${this.$attrs.url}${getParams}` : `https://social-plugins.line.me/lineit/share?url=${this.url}${getParams}`
		this.title = this.$attrs.title || `แชร์ ${this.$attrs.url || this.url} ในไลน์`
	}
}

</script>
